// services/auth.service.js
import api from '@/api/fetchClient'

export default {
  async login(payload) {
    return api.post('auth/login', payload, { authorized: false })
  },
  async SignUp(payload) {
    return api.post('auth/signup', payload, { authorized: false })
  },
  async register(payload) {
    return api.post('auth/register', payload, { authorized: false })
  },
  async refresh(refreshToken) {
    return api.post('auth/refresh', { refreshToken }, { authorized: false })
  },
  async logout(refreshToken) {
    return api.post('auth/logout', { refreshToken }, { authorized: true })
  }
}
